import React, { Component } from "react";
import { withRouter } from "react-router";
import { isBefore, isAfter } from "date-fns";
import Loader from "Loader";
import Button from "Button";
import RebookingIcon from "RebookingIcon";
import Can from "Can";
import Table from "Table";
import { urlFromBooking } from "route-helper";
import {
  sendingSiteDescription,
  receivingSiteDescription,
  formatTrailer
} from "booking-helper";
import { formatWithDefaultTz } from "date-helper";

class ListView extends Component {
  goToBooking(booking) {
    const url = urlFromBooking(booking);
    this.props.history.push({
      pathname: url
    });
  }

  isItOverdue(slotStart, slotEnd, updated_at, status) {
    const now = new Date();
    return (
      (isBefore(updated_at, slotEnd) && isAfter(updated_at, slotStart)) ||
      isBefore(now, slotStart) ||
      status != null
    );
  }

  driverActionButton(booking) {
    if (booking.haulier === null) {
      return "";
    } else if (
      !["new", "staged", "ready_for_driver"].includes(booking.status) &&
      booking.direction === "inbound" &&
      !booking.driverName
    ) {
      return booking.isRebooking ? "" : "Driver Departed";
    } else if (booking.mission && booking.mission.operationStatus === 2) {
      return (
        <Can when="bookings.list.checkIn">
          <Button
            variant="primary"
            size="tiny"
            title="Validate"
            onClick={() => this.props.driverActions(booking.id, "Check In")}
          />
        </Can>
      );
    } else if (booking.status === "staged_arrived") {
      return (
        <Can when="bookings.list.checkIn">
          <Button
            variant="red"
            size="tiny"
            title="Check In 2nd"
            onClick={() => this.props.driverActions(booking.id, "Check In")}
          />
        </Can>
      );
    } else if (
      (booking.status === "new" && booking.direction === "inbound") ||
      (booking.status === "ready_for_driver" &&
        booking.direction === "inbound" &&
        !booking.driverName &&
        !booking.vehicleReg) ||
      booking.status === "staged" ||
      (!booking.driverName &&
        !booking.vehicleReg &&
        booking.direction === "outbound")
    ) {
      return (
        <Can when="bookings.list.checkIn">
          <Button
            variant="primary"
            size="tiny"
            title="Check In"
            onClick={() => this.props.driverActions(booking.id, "Check In")}
          />
        </Can>
      );
    } else if (
      booking.direction !== "internal" &&
      (!["ready_for_driver", "completed", "staged_arrived"].includes(
        booking.status
      ) ||
        booking.status === "completed")
    ) {
      const title =
        booking.direction === "outbound" ? "Off Site" : "Leave Solo";
      return (
        <Can when="bookings.list.offSite">
          <Button
            variant="secondary-30"
            size="tiny"
            title={title}
            onClick={() =>
              this.props.driverActions(booking.id, "Driver Off Site")
            }
          />
        </Can>
      );
    } else if (booking.status === "staged_arrived") {
      return (
        <Button
          variant="secondary"
          size="tiny"
          title="Off Site"
          disabled={booking.trailer.zone ? "" : "disabled"}
          onClick={() => this.props.driverActions(booking.id, "Staged Load")}
        />
      );
    } else if (booking.status === "ready_for_driver") {
      const title =
        booking.direction === "outbound" ? "Off Site" : "Leave Solo";
      return (
        <>
          <Can when="bookings.list.offSite">
            <Button
              variant="secondary-30"
              size="tiny"
              title={title}
              style={{ marginBottom: "0.5rem" }}
              onClick={() =>
                this.props.driverActions(booking.id, "Driver Off Site")
              }
            />
          </Can>
          <Can when="bookings.list.checkOut">
            <Button
              variant="secondary"
              size="tiny"
              title="Check Out"
              onClick={() => this.props.driverActions(booking.id, "Check Out")}
            />
          </Can>
        </>
      );
    }

    return "";
  }

  buildRows() {
    return this.props.bookings.map(booking => {
      const isOverdue = !this.isItOverdue(
        booking.slotStart,
        booking.slotEnd,
        booking.updatedAt,
        booking.status
      );
      const trailerCell = isOverdue ? "OVERDUE" : formatTrailer(booking);
      const journeyRef = (
        <span>
          {booking.journeyReference}
          {booking.appointment && booking.appointment.data.column_number
            ? ` (${booking.appointment.data.column_number})`
            : ""}
        </span>
      );
      const statusText =
        booking.haulier === null
          ? "PROPOSED"
          : booking.status.replace(/_/g, " ");

      return [
        [<RebookingIcon booking={booking} />, { style: { width: "20px", paddingRight: "0" } }],
        formatWithDefaultTz(booking.slotStart, "DD-MM-YYYY"),
        formatWithDefaultTz(booking.slotStart, "HH:mm:ss"),
        booking.appointment ? booking.appointment.data.eta : "",
        [<span>{booking.direction}</span>, { style: { textTransform: "capitalize" } }],
        trailerCell,
        booking.numberOfPallets,
        booking.loadType,
        [
          <span
            className="booking-list-link"
            onClick={() => this.goToBooking(booking)}
          >
            {journeyRef}
          </span>
        ],
        booking.appointment && booking.appointment.data["journey_tag"]
          ? booking.appointment.data["journey_tag"]
          : "",
        booking.appointment ? booking.appointment.loadNo : booking.poNumber,
        sendingSiteDescription(booking),
        receivingSiteDescription(booking),
        booking.vehicleReg,
        [<span>{statusText}</span>, { style: { textTransform: "capitalize" } }],
        [this.driverActionButton(booking)]
      ];
    });
  }

  render() {
    if (this.props.bookingsLoading || this.props.loading) {
      return (
        <div className="calendar-view__loader">
          <Loader />
        </div>
      );
    }

    const headers = [
      "",
      "Date",
      "Slot Start",
      "ETA",
      "Direction",
      "Trailer",
      "Pallets",
      "Load Type",
      "Journey Ref",
      "Tag",
      "Load/Receipt",
      "Sending Site",
      "Receiving Site",
      "Reg",
      "Status",
      ""
    ];

    return (
      <>
        {!this.props.bookings.length && (
          <p className="booking-list--empty">
            No bookings for the selected day.
          </p>
        )}
        {!!this.props.bookings.length && (
          <Table
            className="booking-list-table"
            headers={headers}
            rows={this.buildRows()}
            noDataMessage="No bookings for the selected day."
          />
        )}
      </>
    );
  }
}

export default withRouter(ListView);
